import BuildDetailsPage from '@/pages/BuildDetailsPage/BuildDetailsPage';

import { renderPageComponent } from '@/utils/react_page';
renderPageComponent(BuildDetailsPage);